'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { trackEvent } from './posthog';
import { EVENTS } from './events';

const MIN_TIME_MS = 5000; // Only track if user spent at least 5s

export function useTimeOnPage(pageName) {
  const pathname = usePathname();
  const startRef = useRef(null);
  const activeRef = useRef(0);
  const lastActiveRef = useRef(null);

  useEffect(() => {
    startRef.current = Date.now();
    activeRef.current = 0;
    lastActiveRef.current = Date.now();

    const handleVisibility = () => {
      if (document.hidden) {
        // Page became hidden — accumulate active time
        if (lastActiveRef.current) {
          activeRef.current += Date.now() - lastActiveRef.current;
          lastActiveRef.current = null;
        }
      } else {
        // Page became visible again
        lastActiveRef.current = Date.now();
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);

      // Accumulate final active time
      if (lastActiveRef.current) {
        activeRef.current += Date.now() - lastActiveRef.current;
      }

      const totalTimeMs = Date.now() - startRef.current;
      const activeTimeMs = activeRef.current;

      if (activeTimeMs >= MIN_TIME_MS) {
        trackEvent(EVENTS.ENGAGEMENT_TIME_ON_PAGE, {
          page_name: pageName,
          page_path: pathname,
          total_time_seconds: Math.round(totalTimeMs / 1000),
          active_time_seconds: Math.round(activeTimeMs / 1000),
        });
      }
    };
  }, [pathname, pageName]);
}
